import styled from '@emotion/styled'
import { TCards } from '@lbs/shared-rp-types'
import { FC, ImgHTMLAttributes } from 'react'

type CardProps = ImgHTMLAttributes<HTMLImageElement> & {
  value: TCards
  className?: string
}

const Img = styled.img`
  display: block;
  width: 100%;
  height: 100%;
`

const Card: FC<CardProps> = ({ value, className, ...rest }) => {
  const url = `${process.env.PUBLIC_URL}/cards/${value}.svg`

  return <Img src={url} alt={value} className={className} {...rest} />
}

export default Card
